import _ from 'underscore';

import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import filterNumbers from 'notebook/tables/excess/util/filterNumbers';
import {TypedValue} from 'notebook/tables/TableConstants';
import {coerceToPrimitive} from 'notebook/tables/typed-values/DataTypes';

export default {
  name: 'MAX',
  category: FunctionCategory.STATS,
  shortDescription: 'Maximum value in a numeric dataset.',
  description: 'Returns the maximum value in a numeric dataset.',
  params: [
    {
      name: 'value',
      type: ArgType.any,
      description: 'The first value or range to consider when calculating the maximum value.',
      coerce: (typedValue: TypedValue, languageTag?: string | null) =>
        coerceToPrimitive(typedValue, {
          shouldCoerceStringToNumber: true,
          shouldCoerceDateToNumber: true,
          languageTag,
        }),
    },
  ],
  repeatableLastParamType: ArgType.any,
  repeatableLastParamDescription:
    'Additional values or ranges to consider when calculating the maximum value.',

  eval: (...values): number => {
    const numberValues = filterNumbers(values);
    if (numberValues.length === 0) {
      return 0;
    } else {
      return _.max(numberValues);
    }
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
